import { useContext } from "react"
import { RiCloseFill } from "react-icons/ri"
import { AppLink, AppSpan, AppText, AuthOtpLabel, Button, CustomContainer, FlexRow, Form, FormGroup, GridContainer, ScreenTitle } from "src/style"
// import { ReactComponent as PopupLockIcon } from 'src/assets/img/forgot-password-lock.svg'
import PopupLockIcon from 'src/assets/svg/forgot-password-lock'
import { AppCenterPopup, CenterPopupHeader, CenterPopupHeaderD3 } from "src/component"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import ApiContext from "src/provider/API/call-service"
import ResendIcon from 'src/assets/svg/resend-otp-icon'
import { handleTypeNumberControl } from "src/utils/utility"
import { Design } from 'src/model'

export const OtpVerification: React.FC<any> = ({formData, handleInput, resendOtpMethod, next, close}) => {
    const {info} = useContext(AppInfoContext)
    const {notifier} = useContext(VisibilityContext)
    const {API} = useContext(ApiContext)

    const handleCode = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length < 7) {
            // const isNumber = /^\d+$/.test(e.target.value)
            // if (!isNumber) return false
            handleInput(e)
        }
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        if (formData.otp.length != 6) return notifier.show('Kindly provide a valid otp', 'Validation Response')
        next()
    }

    return (
        <AppCenterPopup height='50' zIndex='8' close={close}>
            <CenterPopupHeader icon={<PopupLockIcon className='icon-component'/>} close={close} />
            {/* { info.institutionData.design != Design.DESIGN_3 ?
                <CenterPopupHeader icon={<PopupLockIcon className='icon-component'/>} close={close} />
                :<CenterPopupHeaderD3 title='One Time Password' close={close} />
            } */}
            <CustomContainer height="39" className='popup-content-container'>
                <CustomContainer topMargin="2">
                    <ScreenTitle textSize="2.2" fontWeight="700" align="center">One Time Password</ScreenTitle>
                    <Form onSubmit={handleProceed} topMargin='2'>
                        <AppSpan>
                            Please enter the One Time Password (OTP) sent to your Phone Number 
                            <AppSpan color='#0EA59D' fontWeight='600'> {info.otpPhoneNo} </AppSpan>
                        </AppSpan>

                        <FlexRow 
                            width="auto" sizeUnit="" 
                            topMargin='2' gap='1.4'
                        >
                            <input 
                                className='display-hidden' id='code' 
                                name="otp" value={formData?.otp} 
                                onChange={handleCode} type='number'
                                onKeyDown={handleTypeNumberControl}
                                onKeyUp={handleTypeNumberControl}
                                autoFocus={true} autoComplete="off"
                            />
                            <AuthOtpLabel className={`code-verification ${formData?.otp.length === 0 ? 'active-otp-box' : ''}`} htmlFor='code' >{formData?.otp[0] ? '*' : ''}</AuthOtpLabel>
                            <AuthOtpLabel className={`code-verification ${formData?.otp.length === 1 ? 'active-otp-box' : ''}`} htmlFor='code' >{formData?.otp[1] ? '*' : ''}</AuthOtpLabel>
                            <AuthOtpLabel className={`code-verification ${formData?.otp.length === 2 ? 'active-otp-box' : ''}`} htmlFor='code' >{formData?.otp[2] ? '*' : ''}</AuthOtpLabel>
                            <AuthOtpLabel className={`code-verification ${formData?.otp.length === 3 ? 'active-otp-box' : ''}`} htmlFor='code' >{formData?.otp[3] ? '*' : ''}</AuthOtpLabel>
                            <AuthOtpLabel className={`code-verification ${formData?.otp.length === 4 ? 'active-otp-box' : ''}`} htmlFor='code' >{formData?.otp[4] ? '*' : ''}</AuthOtpLabel>
                            <AuthOtpLabel className={`code-verification ${formData?.otp.length >= 5 ? 'active-otp-box' : ''}`} htmlFor='code' >{formData?.otp[5] ? '*' : ''}</AuthOtpLabel>
                        </FlexRow>

                        <GridContainer
                            bgColor='#E7F6F5' minHeight='6.2' radius='0.8'
                            shadow='0px 1px 2px rgba(16, 24, 40, 0.05)'
                            padding='2' topPadding='1' bottomPadding='1'
                            topMargin='2.5' bottomMargin="3"
                        >
                            <FlexRow gap='1.5' className='test-safari'>
                                <ResendIcon className='icon-component' />
                                <AppText textSize='1.2' color='#0A756F'>Did not receive OTP.
                                    <AppLink textSize='1.2' color='#0A756F' fontWeight='700' hoverColor='#000000' onClick={resendOtpMethod}> Tap here to resend </AppLink> 
                                </AppText>
                            </FlexRow>
                        </GridContainer>
                        
                        <Button 
                            width='100' sizeUnit="%" height='4.4' 
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F'
                        >
                            Confirm
                        </Button>
                    </Form>
                </CustomContainer>
            </CustomContainer>
        </AppCenterPopup>
    )
}